import { Component, computed, effect, input, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { GeneralDeviceDto } from '../../../../core/mceapi.client.generated';
import { FormDirective } from '../../../../shared/directives/form.directive';
import { FieldTree, FormField, SchemaPathTree, max, min, required } from '@angular/forms/signals';
import { match, Option } from '../../../../shared/functions/functional';

export interface GeneralDevice {
  ioc: number;
  ief: number;
}
export function buildGeneralSchema(path: SchemaPathTree<GeneralDevice>) {

  required(path.ioc, { message: `Current is required` });
  min(path.ioc, 0, { message: `Current must be positive` });
  max(path.ioc, 10800, { message: `Current must be less than or equal to 10800 A` });

}
export function createGeneralDevice(dto: Option<GeneralDeviceDto>) {
  return signal<GeneralDevice>(
    match(
      () => ({ioc:0, ief:0}),
      (x: GeneralDeviceDto): GeneralDevice => {
        if (x.ioc === undefined || x.ief === undefined) {
          throw new Error('General protective device DTO is missing required values.');
        }

        return { ioc: x.ioc, ief: x.ief };
      })(dto));
}

  export function createGeneralDeviceDto(model: FieldTree<GeneralDevice>) {
    return signal<GeneralDeviceDto>({
      ioc: model.ioc().value(),
      ief: model.ief().value()
    });
  }

@Component({
  selector: 'protection-general-device',
  imports: [FormField,MatInputModule,

    FormDirective, FormsModule, ReactiveFormsModule ],
  templateUrl: './general-device.component.html',
})
export class GeneralDeviceComponent {

  readonly form = input.required<FieldTree<GeneralDevice>>();

  /// Currently not using ief, so set to same as ioc
  _ = effect(() => {
    if (this.form().ioc().valid() && this.form().ioc().dirty()) 
      this.form().ief().value.set(this.form().ioc().value());
  });

}
